/*
*
* File JS per le animazioni
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//


/**
*	Funzione di animazione body on load
*/
const animateBody = () => {

    let bodyAnimate = document.querySelector('body.body-animate');
    
    if (!bodyAnimate) return;

    bodyAnimate.classList.add('animate');
}


/**
*	Funzione di animazioni delle sections
*/
const animateSections = () => {
    let controller = new ScrollMagic.Controller();
    let allSectionAnimate = document.querySelectorAll('.section-animate');

    if (!allSectionAnimate) return;

    allSectionAnimate.forEach(el => {
        new ScrollMagic.Scene({
            triggerElement: el,
            offset: 0,
            triggerHook: 0.8,
            reverse: false,
        })
        // .addIndicators()
        .setClassToggle(el, 'animate')
        .addTo(controller);
    });
}


// EXPORT
//--------------------------------------------------------------------//

const initAnimations = () => {
    animateSections();

    window.addEventListener('load', animateBody);
}

export default initAnimations;

//--------------------------------------------------------------------//